/**
 * Inline stroke icons, so they inherit `currentColor` and pick up the active
 * nav state without a second asset. Paths are pipe-separated to keep the icon
 * table readable — same approach as the Conduit admin portal.
 */
export const Ico = ({ d }: { d: string }) => (
  <svg
    className="nav-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"
  >
    {d.split('|').map((p, i) => <path key={i} d={p} />)}
  </svg>
);

export const ICON = {
  overview: 'M3 3v18h18|M7 15l3-4 3 3 4-6',
  tenants: 'M3 21h18|M5 21V7l8-4v18|M19 21V11l-6-3|M9 9v.01|M9 12v.01|M9 15v.01|M9 18v.01',
  users: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2|M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8|M22 21v-2a4 4 0 0 0-3-3.87|M16 3.13a4 4 0 0 1 0 7.75',
  sync: 'M21 2v6h-6|M3 12a9 9 0 0 1 15-6.7L21 8|M3 22v-6h6|M21 12a9 9 0 0 1-15 6.7L3 16',
  plans: 'M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z|M7 7h.01',
  admins: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z|M9 12l2 2 4-4',
  audit: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z|M14 2v6h6|M16 13H8|M16 17H8|M10 9H8',
  back: 'M19 12H5|M12 19l-7-7 7-7',
  plug: 'M9 2v6|M15 2v6|M6 8h12v3a6 6 0 0 1-12 0V8z|M12 17v5',
  // Conduit's own `requests` glyph, so the notification reads identically in
  // both admin portals: a message bubble carrying an exclamation.
  requests: 'M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z|M12 7v4|M12 14v.01',
  bulb: 'M9 18h6|M10 22h4|M12 2a7 7 0 0 0-4 12.7V17h8v-2.3A7 7 0 0 0 12 2z',
  sun: 'M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10z|M12 1v2|M12 21v2|M4.2 4.2l1.4 1.4|M18.4 18.4l1.4 1.4|M1 12h2|M21 12h2|M4.2 19.8l1.4-1.4|M18.4 5.6l1.4-1.4',
  moon: 'M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z',

} as const;
